import { render } from "./Footer.vue?vue&type=template&id=39656634&bindings={\"showPrivacyForm\":\"data\",\"locationIcon\":\"options\"}"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
script.render = render

export default script